import moment from 'moment/src/moment'
import i18n from '@/i18n.js'

/**
 * Получаем value в секундах, возвращаем строку минуты и секунды
 * */
export default function timeString(value, isShort = false, withoutSec = false) {
  let sec = 0,
    min = 0,
    hour = 0,
    str = ''

  if (!value) {
    return '?'
  }

  let duration = moment.duration(value, 'seconds')
  sec = duration.get('seconds')
  min = duration.get('minutes')
  hour = duration.get('hours')

  if ((sec < 10 && isShort) || ((hour !== 0 || min !== 0) && sec < 10)) {
    sec = '0' + sec
  }

  if (min < 10 && (isShort || hour !== 0)) {
    min = '0' + min
  }

  if (isShort) {
    str = min + ':' + sec
    if (hour !== 0) {
      str = hour + ':' + str
    }
  } else {
    let strSec = sec + ' ' + i18n.tc('unit.sec', 2)

    if (hour !== 0) {
      if (withoutSec) {
        str = hour + ' ' + i18n.t('unit.h') + ' ' + min + ' ' + i18n.tc('unit.min', 1)
      } else {
        str = hour + ' ' + i18n.t('unit.h') + ' ' + min + ` ${i18n.tc('unit.min', 2)} ` + strSec
      }
    } else if (min !== 0) {
      str = min + ` ${i18n.tc('unit.min', 2)} `
      if (!withoutSec) str += strSec
    } else {
      str = sec + ' ' + i18n.tc('unit.sec', 2)
    }
  }
  return str
}
